<template>
  <v-container fluid>
    <div class="pa-3" style="font-size:10px;">BusienssList</div>
    <v-row align="start" justify="center">
      <v-col cols="12" sm="8" md="10">
        <v-card class="elevation-4">
          <v-card-title>
            Business List
            <div class="flex-grow-1"></div>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
            <v-btn color="primary" class="ml-3" @click="$router.push('/agent/createbusiness')">Create Business</v-btn>
          </v-card-title>
          <v-card-text>
            <v-divider></v-divider>
            <v-data-table
              :headers="headers"
              :items="businesses"
              :items-per-page="20"
              :search="search"
              class="elevation-1"
              :hide-headers="isMobile"
            >
              <template v-slot:item.logo="{ item }">
                
                <v-avatar>
                  <img :src="item.logo" :alt="item.businessName" />
                </v-avatar>
              </template>
              <template v-slot:item.action="{ item }">
                <v-icon small class="mr-2" @click="editItem(item)">edit</v-icon>
                <v-icon small @click="deleteItem(item)">delete</v-icon>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
export default {
  data: () => ({
    search: "",
    headers: [
     
      { text: "Logo", value: "logo", sortable: false },
      { text: "Business Name", value: "businessName" },
      { text: "Business Type", value: "businessType"},
      { text: "Email", value: "email" },
      { text: "Phone", value: "phone" },
      { text: "Tags Assigned", value: "tagsassigned",align:"end" },
      { text: "Created At", value: "created_at" },
      { text: "Actions", value: "action", sortable: false }
    ],
    businesses: []
  }),
  created() {
    this.$http
      .get(this.$apidomain+"agent/businesslist")
      .then(res => {
       this.businesses = res.data.businesses;
      })
      .catch(err => {
        console.log(err.response);
      });
  },
  methods: {
    editItem(item){
        this.$router.push({name:'editbusiness',params:{id:item.id}});
    },
    deleteItem(item) {
        
      if (confirm("Are you sure you want to delete this business?")) {
          this.$http
      .post(this.$apidomain+"agent/businessdelete/"+item.id)
      .then(res => {
        this.businesses = res.data.businesses;
      })
      .catch(err => {
        console.log(err.response);
      });
      }
    },
    createagent(){
        this.$router.push('/createbusiness');
    }
  }
};
</script>
<style >

</style>